// import React, { useEffect, useState, useMemo, useRef } from "react";
// import { Line } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Tooltip,
//   Legend,
//   Title,
// } from "chart.js";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import * as XLSX from "xlsx";

// ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, Title);

// function RpmLineChart({ dataa }) {
//   const chartRef = useRef(null);
//   const [modalOpen, setModalOpen] = useState(false);
//   const menuRef = useRef();
// const chartContainerRef = useRef(null);
// const [isFullScreen, setIsFullScreen] = useState(false);
//   const handleDownload = (type) => {
//     if (!chartRef.current) return;
//     const chart = chartRef.current;
//     const canvas = chart.canvas;

//     const tempCanvas = document.createElement("canvas");
//     tempCanvas.width = canvas.width;
//     tempCanvas.height = canvas.height;
//     const ctx = tempCanvas.getContext("2d");

//     ctx.fillStyle = "#ffffff";
//     ctx.fillRect(0, 0, canvas.width, canvas.height);
//     ctx.drawImage(canvas, 0, 0);

//     const link = document.createElement("a");
//     link.download = `chart.${type}`;
//     link.href = tempCanvas.toDataURL(`image/${type}`);
//     link.click();
//     setModalOpen(false);
//   };
// const handlePDFDownload = async () => {
//   if (!chartRef.current) return;
//   const canvas = chartRef.current.canvas;

//   const imgData = canvas.toDataURL("image/png", 1.0);
//   const pdf = new jsPDF({
//     orientation: canvas.width > canvas.height ? "landscape" : "portrait",
//     unit: "pt",
//     format: [canvas.width, canvas.height],
//   });

//   pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
//   pdf.save("chart.pdf");
//   setModalOpen(false);
// };
// const toggleFullScreen = () => {
//   const elem = chartContainerRef.current;
//   if (!document.fullscreenElement) {
//     if (elem.requestFullscreen) elem.requestFullscreen();
//     setIsFullScreen(true);
//   } else {
//     if (document.exitFullscreen) document.exitFullscreen();
//     setIsFullScreen(false);
//   }
// };

// // Ensure state syncs on exit
// useEffect(() => {
//   const handleFullScreenChange = () => {
//     const isNowFull = !!document.fullscreenElement;
//     setIsFullScreen(isNowFull);
//   };
//   document.addEventListener("fullscreenchange", handleFullScreenChange);
//   return () => {
//     document.removeEventListener("fullscreenchange", handleFullScreenChange);
//   };
// }, []);
// const handleSVGDownload = () => {
//   if (!chartRef.current) return;
//   const canvas = chartRef.current.canvas;
//   const imgData = canvas.toDataURL("image/png");

//   const svgContent = `
//     <svg xmlns="http://www.w3.org/2000/svg" width="${canvas.width}" height="${canvas.height}">
//       <image href="${imgData}" height="${canvas.height}" width="${canvas.width}" />
//     </svg>
//   `.trim();

//   const blob = new Blob([svgContent], { type: "image/svg+xml;charset=utf-8" });
//   const url = URL.createObjectURL(blob);
//   const link = document.createElement("a");
//   link.href = url;
//   link.download = "chart.svg";
//   link.click();
//   setModalOpen(false);
// };
// const handleXLSDownload = () => {
//   const wsData = [
//     ["Date", "Systolic", "Diastolic", "Pulse", "Weight"],
//     ...formattedData.map((row) => [
//       row.date,
//       row.systolic ?? "",
//       row.diastolic ?? "",
//       row.pulse ?? "",
//       row.weight ?? "",
//     ]),
//   ];

//   const worksheet = XLSX.utils.aoa_to_sheet(wsData);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Chart Data");

//   XLSX.writeFile(workbook, "chart-data.xlsx");
//   setModalOpen(false);
// };

//   const printChart = () => {
//     if (!chartRef.current) return;
//     const canvas = chartRef.current.canvas;
//     const dataUrl = canvas.toDataURL();
//     const win = window.open();
//     win.document.write(`<img src="${dataUrl}" onload="window.print();window.close()">`);
//   };

//   const handleCSVDownload = () => {
//     const csv = ["Date,Systolic,Diastolic,Pulse,Weight"];
//     formattedData.forEach((row) => {
//       csv.push([
//         row.date,
//         row.systolic ?? "",
//         row.diastolic ?? "",
//         row.pulse ?? "",
//         row.weight ?? "",
//       ].join(","));
//     });
//     const blob = new Blob([csv.join("\n")], { type: "text/csv" });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = "chart-data.csv";
//     link.click();
//     setModalOpen(false);
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     const options = {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     };
//     return date.toLocaleString("en-US", options);
//   };

//   const formattedData = useMemo(() => {
//     return (
//       dataa?.datetime?.map((datetime, index) => ({
//         date: formatDate(datetime),
//         ...(dataa.systolic && dataa.diastolic && dataa.pulse
//           ? {
//               systolic: dataa.systolic[index],
//               diastolic: dataa.diastolic[index],
//               pulse: dataa.pulse[index],
//             }
//           : {}),
//         ...(dataa.weight
//           ? {
//               weight: dataa.weight[index],
//               weightUnits: dataa.weightunits?.[index],
//             }
//           : {}),
//       })) || []
//     );
//   }, [dataa]);

//   const commonLineStyle = (color) => ({
//     fill: false,
//     lineTension: 0.3,
//     backgroundColor: color,
//     borderColor: color,
//     borderCapStyle: "round",
//     borderJoinStyle: "round",
//     pointBorderColor: color,
//     pointBackgroundColor: color,
//     pointBorderWidth: 1,
//     pointHoverRadius: 5,
//     pointHoverBackgroundColor: color,
//     pointHoverBorderColor: "#fff",
//     pointHoverBorderWidth: 5,
//     pointRadius: 0,
//     pointHitRadius: 5,
//   });

//   const rawdata1 = { ...commonLineStyle("#2a2c30") };
//   const rawdata2 = { ...commonLineStyle("#f84c1e") };
//   const rawdata3 = { ...commonLineStyle("#1e90ff") };

//   const [renderdata, setRenderData] = useState({ labels: [], datasets: [] });

//   useEffect(() => {
//     const updatedData = {
//       labels: formattedData.map((entry) => entry.date),
//       datasets: [],
//     };

//     if (formattedData.some((entry) => entry.systolic !== undefined)) {
//       updatedData.datasets.push({
//         ...rawdata2,
//         data: formattedData.map((e) => e.systolic),
//         label: "Systolic",
//       });
//       updatedData.datasets.push({
//         ...rawdata1,
//         data: formattedData.map((e) => e.diastolic),
//         label: "Diastolic",
//       });
//       updatedData.datasets.push({
//         ...rawdata3,
//         data: formattedData.map((e) => e.pulse),
//         label: "Pulse",
//       });
//     }

//     if (formattedData.some((entry) => entry.weight !== undefined)) {
//       updatedData.datasets.push({
//         ...rawdata2,
//         data: formattedData.map((e) => e.weight),
//         label: "Weight",
//       });
//     }

//     setRenderData(updatedData);
//   }, [formattedData]);

//   const options = {
//     responsive: true,
//       maintainAspectRatio: false,
//     plugins: {
//       tooltip: {
//         enabled: true,
//         mode: "nearest",
//         intersect: false,
//         callbacks: {
//           label: (tooltipItem) => `${tooltipItem.dataset.label}: ${tooltipItem.raw}`,
//         },
//       },
//       legend: {
//         display: true,
//         position: "bottom",
//         labels: {
//           usePointStyle: true,
//           boxWidth: 20,
//         },
//       },
//     },
//     scales: {
//       y: {
//         ticks: { stepSize: 10 },
//         grid: { drawTicks: false },
//       },
//       x: {
//         grid: { display: false },
//       },
//     },
//   };

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (menuRef.current && !menuRef.current.contains(e.target)) {
//         setModalOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <div className="relative w-full h-full bg-white"
//     ref={chartContainerRef}
//     >
//       <div className="flex justify-end px-4 pt-2" ref={menuRef}>
//         <button
//           className="text-gray-600 hover:text-black dark:text-white"
//           onClick={() => setModalOpen(true)}
//         >
//           ☰
//         </button>
//       </div>

//       <Line ref={chartRef} options={options} data={renderdata} />

//       {modalOpen && (
//         <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
//           <div className="bg-white text-sm rounded shadow-lg w-[90%] max-w-[512px]" ref={menuRef}>
//             <div className="flex justify-between items-center px-4 py-2 border-b">
//         <button
//   className="text-blue-600 hover:underline"
//   onClick={toggleFullScreen}
// >
//   {isFullScreen ? "Exit full screen" : "View in full screen"}
// </button>
//               <button className="text-blue-600 hover:underline" onClick={printChart}>
//                 Print chart
//               </button>
//             </div>

//             <div className="flex flex-wrap justify-start px-4 py-2 border-b gap-4 text-blue-600">
//               <button onClick={() => handleDownload("png")} className="hover:underline">Download PNG</button>
//               <button onClick={() => handleDownload("jpeg")} className="hover:underline">Download JPEG</button>
//             <button onClick={handlePDFDownload} className="hover:underline">Download PDF</button>
//   <button onClick={handleSVGDownload} className="hover:underline">Download SVG vector image</button>
//             </div>

//             <div className="flex flex-wrap justify-start px-4 py-2 gap-4 text-blue-600">
//               <button onClick={handleCSVDownload} className="hover:underline">Download CSV</button>
//            <button onClick={handleXLSDownload} className="hover:underline">Download XLS</button>

//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default RpmLineChart;

import React, { useEffect, useState, useMemo, useRef } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
  Filler,
} from "chart.js";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import dayjs from "dayjs";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
  Filler
);

function RpmLineChart({ dataa }) {
  const chartRef = useRef(null);
  const [modalOpen, setModalOpen] = useState(false);
  const menuRef = useRef();
  const chartContainerRef = useRef(null);
  const [isFullScreen, setIsFullScreen] = useState(false);

  // ---------- Helpers ----------
  const formatDateReadable = (dateString) => {
    const date = new Date(dateString);
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    return date.toLocaleString("en-US", options);
  };

  // Build a normalized array like your first component
  const formattedData = useMemo(() => {
    const res =
      dataa?.datetime?.map((dt, idx) => ({
        // store both ISO (for chart label/tooltip) and pretty (for exports)
        iso: new Date(dt).toISOString(),
        readable: formatDateReadable(dt),
        ...(dataa.systolic && dataa.diastolic && dataa.pulse
          ? {
              systolic: Number(dataa.systolic[idx]),
              diastolic: Number(dataa.diastolic[idx]),
              pulse: Number(dataa.pulse[idx]),
            }
          : {}),
        ...(dataa.weight
          ? {
              weight: Number(dataa.weight[idx]),
              weightUnits: dataa.weightunits?.[idx],
            }
          : {}),
      })) || [];
    return res;
  }, [dataa]);

  // Same dataset style as Infograph
  const mkStyle = (color) => ({
    fill: false,
    tension: 0.3,
    borderColor: color,
    backgroundColor: color,
    pointStyle: "circle",
    pointRadius: 4,
    pointHoverRadius: 6,
    pointBorderWidth: 2,
    pointBackgroundColor: color,
    pointBorderColor: "#ffffff",
    borderWidth: 2,
    hitRadius: 10,
  });

  // Match Infograph colors
  const styleSBP = useMemo(() => mkStyle("#f0841d"), []); // Systolic
  const styleDBP = useMemo(() => mkStyle("#1f2937"), []); // Diastolic
  const stylePR = useMemo(() => mkStyle("#16a34a"), []); // Pulse
  const styleW = useMemo(() => mkStyle("#f84c1e"), []); // Weight

  const [renderdata, setRenderData] = useState({ labels: [], datasets: [] });

  useEffect(() => {
    const labels = formattedData.map((e) => e.iso);
    const datasets = [];

    if (formattedData.some((e) => e.systolic !== undefined)) {
      datasets.push({
        ...styleSBP,
        label: "Systolic",
        data: formattedData.map((e) => e.systolic),
      });
      datasets.push({
        ...styleDBP,
        label: "Diastolic",
        data: formattedData.map((e) => e.diastolic),
      });
      datasets.push({
        ...stylePR,
        label: "Pulse",
        data: formattedData.map((e) => e.pulse),
      });
    }

    if (formattedData.some((e) => e.weight !== undefined)) {
      datasets.push({
        ...styleW,
        label: "Weight",
        data: formattedData.map((e) => e.weight),
      });
    }

    setRenderData({ labels, datasets });
  }, [formattedData]);

  // ---------- External custom tooltip (same as Infograph) ----------
  const externalTooltip = (context) => {
    const { chart, tooltip } = context;

    let tooltipEl = document.querySelector("#chartjs-ext-tooltip-global");
    if (!tooltipEl) {
      tooltipEl = document.createElement("div");
      tooltipEl.id = "chartjs-ext-tooltip-global";
      Object.assign(tooltipEl.style, {
        position: "absolute",
        pointerEvents: "none",
        zIndex: "9999",
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
        padding: "10px 12px",
        minWidth: "140px",
        maxWidth: "240px",
        font: "500 12px Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial",
        opacity: "0",
        transform: "translate(-50%, -100%)",
        transition: "opacity 80ms linear",
      });
      const inner = document.createElement("div");
      inner.className = "inner";
      tooltipEl.appendChild(inner);
      document.body.appendChild(tooltipEl);
    }

    if (tooltip.opacity === 0) {
      tooltipEl.style.opacity = "0";
      return;
    }

if (tooltip.body) {
  const body = tooltip.body[0].lines[0]; // "Systolic: 120"
  const [series, val] = body.split(":").map((s) => s.trim());
  const dotColor =
    (tooltip.labelColors && tooltip.labelColors[0]?.backgroundColor) ||
    "#333";
  const titleISO = tooltip.title && tooltip.title[0];

  // Use Day.js for full formatted date
  const fullDate = titleISO ? dayjs(titleISO).format("ddd, MMM D, YYYY hh:mm A") : "";

  tooltipEl.querySelector(".inner").innerHTML = `
    <div style="display:flex;align-items:center;gap:8px;margin-bottom:4px;">
      <span style="width:8px;height:8px;border-radius:999px;background:${dotColor};display:inline-block"></span>
      <span style="font-weight:600;color:#111827">${series}</span>
    </div>
    <div style="color:#6b7280;margin-bottom:6px">${fullDate}</div>
    <div style="font-weight:600;color:#111827">Value: ${val}</div>
  `;
}


    // Positioning
    const canvasRect = chart.canvas.getBoundingClientRect();
    const caretX = canvasRect.left + window.scrollX + tooltip.caretX;
    const caretY = canvasRect.top + window.scrollY + tooltip.caretY;

    tooltipEl.style.opacity = "1";
    tooltipEl.style.transform = "translate(-50%, -100%)";
    const tw = tooltipEl.offsetWidth;
    const th = tooltipEl.offsetHeight;
    const PAD = 10;

    const vw = window.scrollX + document.documentElement.clientWidth;
    const vh = window.scrollY + document.documentElement.clientHeight;

    let left = caretX;
    const minLeft = window.scrollX + PAD + tw / 2;
    const maxLeft = vw - PAD - tw / 2;
    left = Math.max(minLeft, Math.min(left, maxLeft));

    let top = caretY - PAD - th; // try above
    let transform = "translate(-50%, 0)";
    if (top < window.scrollY + PAD) {
      top = caretY + PAD; // place below
      transform = "translate(-50%, 0)";
    }

    const maxTop = vh - PAD - th;
    top = Math.min(Math.max(top, window.scrollY + PAD), maxTop);

    tooltipEl.style.left = `${left}px`;
    tooltipEl.style.top = `${top}px`;
    tooltipEl.style.transform = transform;
  };

  // ---------- Chart options (match Infograph look) ----------
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "nearest", intersect: false },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: { usePointStyle: true, boxWidth: 6, font: { size: 10 } },
      },
      tooltip: {
        enabled: false,
        external: externalTooltip,
        callbacks: {
          label: (ctx) => `${ctx.dataset.label}: ${ctx.raw}`,
          title: (items) => items[0]?.label ?? "",
        },
      },
    },
    elements: {
      point: { radius: 4, hoverRadius: 6, borderWidth: 2 },
      line: { borderWidth: 2 },
    },
    scales: {
      x: {
        grid: {
          display: true,
          drawTicks: false,
          color: "#E5E7EB",
          borderDash: [4, 6],
        },
        ticks: {
          maxRotation: 0,
          font: { size: 10 },
          callback: (_, index) => {
            const iso = renderdata.labels[index];
            const d = iso ? new Date(iso) : null;
            return d ? d.toLocaleString("default", { month: "long" }) : "";
          },
        },
      },
      y: {
        grid: {
          drawTicks: false,
          color: "#E5E7EB",
          borderDash: [4, 6],
        },
        ticks: { font: { size: 10 } },
      },
    },
  };

  // ---------- Downloads / Print ----------
  const handleDownload = (type) => {
    if (!chartRef.current) return;
    const canvas = chartRef.current.canvas;
    const tempCanvas = document.createElement("canvas");
    tempCanvas.width = canvas.width;
    tempCanvas.height = canvas.height;
    const ctx = tempCanvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(canvas, 0, 0);

    const link = document.createElement("a");
    link.download = `chart.${type}`;
    link.href = tempCanvas.toDataURL(`image/${type}`);
    link.click();
    setModalOpen(false);
  };

  const handlePDFDownload = () => {
    if (!chartRef.current) return;
    const canvas = chartRef.current.canvas;
    const imgData = canvas.toDataURL("image/png", 1.0);
    const pdf = new jsPDF({
      orientation: canvas.width > canvas.height ? "landscape" : "portrait",
      unit: "pt",
      format: [canvas.width, canvas.height],
    });
    pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
    pdf.save("chart.pdf");
    setModalOpen(false);
  };

  const handleSVGDownload = () => {
    if (!chartRef.current) return;
    const canvas = chartRef.current.canvas;
    const imgData = canvas.toDataURL("image/png");
    const svgContent = `
      <svg xmlns="http://www.w3.org/2000/svg" width="${canvas.width}" height="${canvas.height}">
        <image href="${imgData}" height="${canvas.height}" width="${canvas.width}" />
      </svg>
    `.trim();

    const blob = new Blob([svgContent], {
      type: "image/svg+xml;charset=utf-8",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "chart.svg";
    link.click();
    setModalOpen(false);
  };

  const handleXLSDownload = () => {
    const wsData = [
      ["Date", "Systolic", "Diastolic", "Pulse", "Weight"],
      ...formattedData.map((row) => [
        row.readable,
        row.systolic ?? "",
        row.diastolic ?? "",
        row.pulse ?? "",
        row.weight ?? "",
      ]),
    ];
    const worksheet = XLSX.utils.aoa_to_sheet(wsData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Chart Data");
    XLSX.writeFile(workbook, "chart-data.xlsx");
    setModalOpen(false);
  };

  const handleCSVDownload = () => {
    const csv = ["Date,Systolic,Diastolic,Pulse,Weight"];
    formattedData.forEach((row) => {
      csv.push(
        [
          row.readable,
          row.systolic ?? "",
          row.diastolic ?? "",
          row.pulse ?? "",
          row.weight ?? "",
        ].join(",")
      );
    });
    const blob = new Blob([csv.join("\n")], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "chart-data.csv";
    link.click();
    setModalOpen(false);
  };

  const printChart = () => {
    if (!chartRef.current) return;
    const canvas = chartRef.current.canvas;
    const dataUrl = canvas.toDataURL();
    const win = window.open();
    win.document.write(
      `<img src="${dataUrl}" onload="window.print();window.close()">`
    );
  };

  // ---------- Fullscreen ----------
  const toggleFullScreen = () => {
    const elem = chartContainerRef.current;
    if (!document.fullscreenElement) {
      if (elem.requestFullscreen) elem.requestFullscreen();
      setIsFullScreen(true);
    } else {
      if (document.exitFullscreen) document.exitFullscreen();
      setIsFullScreen(false);
    }
  };

  useEffect(() => {
    const handleFullScreenChange = () =>
      setIsFullScreen(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", handleFullScreenChange);
    return () =>
      document.removeEventListener("fullscreenchange", handleFullScreenChange);
  }, []);

  // ---------- Close menu on outside click ----------
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target))
        setModalOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative w-full h-full bg-white" ref={chartContainerRef}>
      <div className="flex justify-end px-4 pt-2" ref={menuRef}>
        <button
          className="text-gray-600 hover:text-black dark:text-white"
          onClick={() => setModalOpen(true)}
        >
          ☰
        </button>
      </div>

<div className="w-full h-full" style={{ position: "relative", overflow: "visible" }}>
  <Line ref={chartRef} options={options} data={renderdata} />
</div>


      {modalOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
          <div
            className="bg-white text-sm rounded shadow-lg w-[90%] max-w-[512px]"
            ref={menuRef}
          >
            <div className="flex justify-between items-center px-4 py-2 border-b">
              <button
                className="text-blue-600 hover:underline"
                onClick={toggleFullScreen}
              >
                {isFullScreen ? "Exit full screen" : "View in full screen"}
              </button>
              <button
                className="text-blue-600 hover:underline"
                onClick={printChart}
              >
                Print chart
              </button>
            </div>

            <div className="flex flex-wrap justify-start px-4 py-2 border-b gap-4 text-blue-600">
              <button
                onClick={() => handleDownload("png")}
                className="hover:underline"
              >
                Download PNG
              </button>
              <button
                onClick={() => handleDownload("jpeg")}
                className="hover:underline"
              >
                Download JPEG
              </button>
              <button onClick={handlePDFDownload} className="hover:underline">
                Download PDF
              </button>
              <button onClick={handleSVGDownload} className="hover:underline">
                Download SVG vector image
              </button>
            </div>

            <div className="flex flex-wrap justify-start px-4 py-2 gap-4 text-blue-600">
              <button onClick={handleCSVDownload} className="hover:underline">
                Download CSV
              </button>
              <button onClick={handleXLSDownload} className="hover:underline">
                Download XLS
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default RpmLineChart;
